export const appModuleMapping = {
  user: {
    icon: 'UserModule',
    desc: 'Manage user credentials, roles, and access permissions',
  },
  organization: {
    icon: 'OrganizationModule',
    desc: 'Encompass all the functions of the organization',
  },
};

export const AppModules = [
  {
    id: 'user',
  },
  {
    id: 'organization',
  },
];
